var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1871_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 15.0106V13.6772H12.6665V7.01058H3.33317V9.67725H1.99984V4.34391C1.99984 3.97725 2.13028 3.66347 2.39117 3.40258C2.6525 3.14125 2.9665 3.01058 3.33317 3.01058H3.99984V1.67725H5.33317V3.01058H10.6665V1.67725H11.9998V3.01058H12.6665C13.0332 3.01058 13.3472 3.14125 13.6085 3.40258C13.8694 3.66347 13.9998 3.97725 13.9998 4.34391V13.6772C13.9998 14.0439 13.8694 14.3579 13.6085 14.6192C13.3472 14.8801 13.0332 15.0106 12.6665 15.0106H9.99984ZM5.33317 16.3439L4.39984 15.4106L6.1165 13.6772H0.666504V12.3439H6.1165L4.39984 10.6106L5.33317 9.67725L8.6665 13.0106L5.33317 16.3439Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1871_1763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.34375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingIcon);
export default __webpack_public_path__ + "static/media/upcoming-icon.9f9c56d93163b8bd5f36fa0192f5fecb.svg";
export { ForwardRef as ReactComponent };